<template>
  <v-combobox
    v-model="internalModel"
    :items="items"
    :item-text="itemText"
    :item-value="itemValue"
    :label="label"
    :chips="true"
    multiple
  />
</template>

<script>
export default {
  name: 'ChipsCombobox',
  props: {
    model: {
      required: true
    },
    itemText: {
      required: true
    },
    itemValue: {
      required: true
    },
    label: {
      required: true
    },
    items: {
      required: true
    }
  },
  data () {
    return {
      internalModel: [],
      paramsLoading: false,
      updatingInternalModel: false
    }
  },
  watch: {
    items: function () {
      this.updatingInternalModel = true
      if (this.isSendUpdate) {
        return
      }
      this.internalModel = []
      var _this = this
      this.items.forEach(function (element) {
        if (_this.model.includes(element[_this.itemValue])) {
          _this.internalModel.push(element)
        }
      })
      setTimeout(function () {
        _this.paramsLoading = false
      }, 1000)
      this.updatingInternalModel = false
    },
    internalModel: function () {
      if (this.updatingInternalModel) {
        return
      }
      var _this = this
      this.model.length = 0
      this.internalModel.forEach(function (element) {
        _this.model.push(element[_this.itemValue])
      })
    }
  }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/shared-components/VChipsCombobox.vue